module.exports = __webpack_public_path__ + "static/candidate-tools-c4188c92dd5e8ec2dd5b1dfbbec021f7.jpg";